export { default } from "./ViewTermsOfService";
